import React from 'react'
import LoadingMessage from '../../../components/LoadingMessage'

function ApplicationsRequesting() {
  return (
    <LoadingMessage>
      Recuperando datos de la solicitud
    </LoadingMessage>
  )
}

export default ApplicationsRequesting
